import React from "react";
import PropTypes from "prop-types";
import Loading from "../../component/Loading/Loading";
import Box from "../../component/Box/Box";
import Notify from "../../services/Notify";
import LsdSelector from "../../lsd/LsdSelector";
import LayerSelector from "./LayerSelector";
import PointFormList from "./point/PointFormList";
import PolygonService from "./PolygonService";
import FormButtons from "../../component/Form/FormButtons";
import { ControlLabel } from "react-bootstrap";
import FormGroup from "react-bootstrap/es/FormGroup";

class PolygonForm extends React.Component {

  service = new PolygonService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.service.findById(id).then(
          data => this.setState(
              {
                loading: false,
                entity: data
              }),
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      )
    }
  }

  submitForm() {
    const existingEntity = this.state.entity && this.state.entity.id;
    const entityVersion = this.state.entity && this.state.entity.version;
    const entity = {
      id: existingEntity,
      friendlyName: this.friendlyName.value.trim(),
      layer: this.layer,
      lsd: this.lsd || (this.state.entity && this.state.entity.lsd),
      points: this.points || (this.state.entity && this.state.entity.points),
      map: {id: this.props.match.params.mapId},
      version: entityVersion
    };

    this.service.save(entity).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) => Notify.error('Falha ao salvar entidade:', error));
  }

  render() {
    const {loading, entity = {}, message} = this.state;
    if (loading) {
      return <Loading/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    return (
        <div>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <Box info>
            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input type="text" className="form-control" placeholder="Nome/Vaga"
                     required
                     name="friendlyName"
                     ref={friendlyName => this.friendlyName = friendlyName}
                     defaultValue={entity && entity.friendlyName}/>
            </FormGroup>
              <LayerSelector defaultValue={entity.layer} setValue={layer => this.layer = layer}/>
              <LsdSelector defaultValue={entity.lsd} setValue={lsd =>
                  this.lsd = lsd
              }/>
            </Box>

            <Box info>
              <PointFormList defaultValue={entity.points} setValue={points => this.points = points}/>

              <FormButtons history={this.props.history}/>
            </Box>
          </form>
        </div>);
  }
}

PolygonForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default PolygonForm;



// WEBPACK FOOTER //
// ./src/map/polygon/PolygonForm.js